<div class='info-label-container'>
  <div class='icon-container'>
    <gux-icon icon-name="alert-warning-triangle"
              slot="icon"
              decorative>
    </gux-icon>
  </div>
  <div class='info-text'>
    <p>
      <ng-content></ng-content>
    </p>
  </div>
</div>
